import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { debinStatusActions, statusTagColor } from "util/debin";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import FormattedAmount from "pages/_components/FormattedAmount";
import useActionByDebinState from "pages/debinPayments/hooks/useActionByDebinState";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import * as i18nUtils from "util/i18n";

const EmitedebinItem = ({ receibedDebin, setDrawer, isDesktop }) => {
    const debin = {
        ...receibedDebin,
        estado: receibedDebin?.status,
        vendedor: { cuit: receibedDebin?.seller?.documentNumber },
    };
    const { options } = useActionByDebinState(debinStatusActions, debin, setDrawer);
    const debitAccountMask = `****${receibedDebin?.buyer?.cbu?.substring(17, 21)}`;
    return (
        <>
            <GridTable.Data
                columnStart={1}
                rowStart={1}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.solicit.date"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={receibedDebin.expirationDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.seller"
                    titleTextType="I18N"
                    valueText={`${receibedDebin.seller.titular}
                    ${receibedDebin.seller.documentType} ${receibedDebin.seller.documentNumber}`}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}
                className="align-items-center">
                {isDesktop ? (
                    <CustomText text={debitAccountMask} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="debin.dateExpitation"
                        titleTextType="I18N"
                        valueText={debitAccountMask}
                        valueTextType="text"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText
                        text={
                            <FormattedAmount
                                currency={receibedDebin.amount.currency}
                                quantity={receibedDebin.amount.quantity}
                            />
                        }
                    />
                ) : (
                    <CustomData
                        titleText="debin.amount"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                currency={receibedDebin.amount.currency}
                                quantity={receibedDebin.amount.quantity}
                            />
                        }
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 5 : 2}
                rowStart={1}
                alignX="center"
                alignY={isDesktop ? "center" : "start"}>
                <InfoTag
                    type="info"
                    message={receibedDebin.status}
                    tagBackground={statusTagColor(receibedDebin.status)}
                    tagClass="tag-word-break"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 2}
                rowStart={isDesktop ? 1 : 2}
                alignX="center"
                alignY={isDesktop ? "center" : "start"}>
                <InfoTag
                    type="info"
                    message={i18nUtils.get(`debin.type.${receibedDebin.type}.label`)}
                    tagBackground="success"
                    tagClass="tag-word-break"
                />
            </GridTable.Data>
            <GridTable.Data
                className="data-menu"
                columnStart={isDesktop ? 7 : 3}
                rowStart={1}
                alignY={isDesktop ? "center" : "start"}
                alignX="center">
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
        </>
    );
};

EmitedebinItem.propTypes = {
    receibedDebin: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
};

export default EmitedebinItem;
